/* eslint-disable no-nested-ternary */
import React from "react";
import {Form, FormGroup, Label} from "reactstrap";
import PropTypes from "prop-types";

import {FormField} from "../../../../../utils/FormFields";

function PhonesTab({person, changedPerson, showChanges, remove}) {
  const editPhone = changedPerson.Phone[0];
  var comparePhone = {};
  person.Phone.forEach(d => {
    if (String(d.PhoneId) == String(editPhone.PhoneId)) {
      comparePhone = d;
    }
  });
  let color = "black";
  if (showChanges) {
    if (comparePhone === undefined) {
      color = "green";
    } else {
      color = remove ? "red" : "#36a9e1";
    }
  }
  return (
    <Form>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "20px",
          display: "block",
          color
        }}
      >
        {showChanges ? (
          <React.Fragment>
            {editPhone !== undefined &&
              (editPhone.PhoneId == 0
                ? "New Phone"
                : remove
                ? "Remove Phone"
                : "Edited Phone")}
          </React.Fragment>
        ) : (
          "Actual Phone"
        )}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          {comparePhone && (
            <FormToShow phone={editPhone} compareDoc={comparePhone} />
          )}
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          {comparePhone && <FormToShow phone={comparePhone} />}
        </FormGroup>
      )}
    </Form>
  );
}

PhonesTab.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
  showChanges: PropTypes.bool.isRequired,
  remove: PropTypes.bool.isRequired
};

PhonesTab.defaultProps = {
  changedPerson: undefined
};

const FormToShow = ({phone, compareDoc}) => (
  <React.Fragment>
    <FormField
      label="Type: "
      value={`${phone.PhoneType}`}
      name="Type"
      changedColor={compareDoc && phone.PhoneType !== compareDoc.PhoneType}
    />
    <FormField
      label="Number: "
      value={`${phone.PhoneNumber}`}
      name="Type"
      changedColor={compareDoc && phone.PhoneNumber !== compareDoc.PhoneNumber}
    />
  </React.Fragment>
);

FormToShow.propTypes = {
  phone: PropTypes.object.isRequired,
  compareDoc: PropTypes.object
};

FormToShow.defaultProps = {
  compareDoc: undefined
};

export default PhonesTab;
